import styled from 'styled-components';

import { CARD_BRAND } from '../../spei.tokens';
import { FINISH } from '../../finish.tokens';

/* Third-party marks. The plate colour comes from the brands' own guidance (see `spei.tokens.ts`),
   which is why this file reaches for CARD_BRAND rather than the studio palette: re-deriving it
   through our light/accent machinery would put a card network on the wrong background. */

export const Marks = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

/** White card the network marks are printed on. Their owners draw them for a light background, so
 *  the plate is what lets one asset serve the dark option card and the light one — and on light,
 *  where the plate matches the card, the hairline keeps it a discrete object. */
export const Plate = styled.span`
  display: inline-flex;
  height: 22px;
  width: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid ${FINISH.methodRowBorder};
  background: ${CARD_BRAND.plate};
`;

/** A network mark inside its plate. Width is set per mark (the two have different aspect ratios,
 *  so matching their heights would make one visually dominate the other) and the height follows. */
export const PlateMark = styled.img<{ $width: number }>`
  width: ${({ $width }) => $width}px;
  height: auto;
  display: block;
`;

/** The Powered-by-Stripe badge. It ships its own dark pill, so it needs no plate. */
export const StripeBadgeMark = styled.img`
  align-self: flex-start;
  width: 84px;
  height: auto;
  display: block;
`;
